import React from 'react';
import { Star, Award, Users } from 'lucide-react';
import { doctorInfo, contactInfo } from '../data/mock';

const HeroSection = () => {
  const whatsappUrl = `https://wa.me/${contactInfo.whatsapp.replace(/\D/g, '')}?text=${encodeURIComponent(contactInfo.whatsappMessage)}`;

  const scrollToServices = () => {
    const element = document.querySelector('#services');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section id="home" className="hero-section">
      <div className="hero-content">
        {/* Main Heading */}
        <h1 className="heading-hero mb-8">
          Piel Sana y Hermosa
          <br />
          <span className="text-accent-purple-400">Comienza Aquí</span>
        </h1>

        {/* Subtitle */}
        <p className="body-large hero-subtitle text-secondary mt-4">
          Atención dermatológica especializada combinando los últimos tratamientos médicos 
          con soluciones estéticas personalizadas para una piel radiante y saludable.
        </p>

        {/* CTA Buttons */}
        <div className="flex flex-col sm:flex-row gap-4 justify-center items-center mb-12">
          <a href={whatsappUrl} className="btn-primary">
            Agendar Consulta
          </a>
          <button onClick={scrollToServices} className="btn-secondary">
            Ver Servicios
          </button>
        </div>

        {/* Trust Indicators */}
        <div className="flex flex-col sm:flex-row items-center justify-center gap-8 text-center mb-8">
          <div className="flex items-center gap-2">
            <div className="flex">
              {[...Array(5)].map((_, i) => (
                <Star key={i} size={16} className="text-accent-orange-400 fill-current" />
              ))}
            </div>
            <span className="mono-text">+1500 Pacientes Felices</span>
          </div>
          
          <div className="flex items-center gap-2">
            <Users size={16} className="text-accent-blue-400" />
            <span className="mono-text">{doctorInfo.experience}</span>
          </div>
          
          <div className="flex items-center gap-2">
            <Award size={16} className="text-accent-green-200" />
            <span className="mono-text">Consejo Mexicano de Dermatología</span>
          </div>
        </div>

        {/* Additional Credentials */}
        <div className="text-center space-y-2 max-w-4xl mx-auto mb-12 px-4">
          <div className="flex items-start justify-center gap-2">
            <Award size={16} className="text-accent-blue-400 flex-shrink-0 mt-0.5" />
            <span className="mono-text text-left">
              Curso de Alta Especialidad en Cirugía Dermatológica y Oncología Cutánea por UANL
            </span>
          </div>
        </div>

        {/* Doctor Image - Now centered below content */}
        <div className="flex justify-center">
          <div className="relative">
            <img 
              src={doctorInfo.image} 
              alt={doctorInfo.name}
              className="w-80 h-80 object-cover object-top rounded-2xl shadow-lg"
            />
            <div className="absolute -bottom-4 left-1/2 transform -translate-x-1/2 voice-card accent-purple p-4 backdrop-blur-sm text-center pointer-events-none">
              <div className="voice-card-title text-sm">{doctorInfo.name}</div>
              <div className="caption">{doctorInfo.credentials}</div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;